import { Box, Center, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import * as _ from 'lodash';
import React, { useCallback } from 'react';
import { useDropzone, FileWithPath } from 'react-dropzone';

import { truncateUploadFileName } from 'packages/common-frontend/utils';
import { FiFilePlus, FiFileMinus, FiUpload } from 'react-icons/fi';

type Props = {
  isDisabled: boolean;
  setFieldValue: (value: FileWithPath) => void;
};
const UploadReceivablesCSVDropzone = ({ isDisabled, setFieldValue }: Props) => {
  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
  } = useDropzone({
    accept: { 'text/csv': ['.csv'] },
    multiple: false,
    onDrop: useCallback((files: FileWithPath[]) => setFieldValue(files[0]), [
      setFieldValue,
    ]),
    disabled: isDisabled,
  });

  const acceptedFileItems = _.map(acceptedFiles, (file: FileWithPath) => (
    <Text key={file.path}>{truncateUploadFileName(file.path)}</Text>
  ));

  const fileRejectionItems = _.map(
    fileRejections,
    ({ file }: { file: FileWithPath }) => (
      <>
        <Text key={file.path}>{truncateUploadFileName(file.path)}</Text>
        <Text>
          Expected file of type <em>csv</em>
        </Text>
      </>
    ),
  );

  const fileSelected = !_.isEmpty(acceptedFiles) || !_.isEmpty(fileRejections);

  return (
    <Box width="100%" cursor="pointer">
      <Center
        border="1px"
        borderRadius="md"
        minHeight="200px"
        flexDirection="column"
        {...getRootProps({ className: 'dropzone' })}
      >
        <input {...getInputProps()} />
        {!_.isEmpty(acceptedFiles) && (
          <>
            <Heading size="sm">
              <Icon as={FiFilePlus} color="green.300" /> Accepted
            </Heading>
            {acceptedFileItems}
          </>
        )}
        {!_.isEmpty(fileRejections) && (
          <>
            <Flex alignItems="center">
              <Icon as={FiFileMinus} color="red.300" />
              <Heading size="sm">Rejected</Heading>
            </Flex>
            {fileRejectionItems}
          </>
        )}
        <Flex
          justifyContent="space-between"
          alignItems="center"
          pt={fileSelected ? '20px' : '0'}
        >
          <Flex direction="column" alignItems="center">
            <Text
              as={fileSelected ? 'sub' : 'i'}
              mb={fileSelected ? '15px' : '0px'}
            >
              Drag a file here, or click to upload.
            </Text>
            <Text as={fileSelected ? 'sub' : 'i'}>
              Allowed file types: .csv
            </Text>
          </Flex>
          <Flex ml="10px">
            <FiUpload />
          </Flex>
        </Flex>
      </Center>
    </Box>
  );
};

export default UploadReceivablesCSVDropzone;
